import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import UITextInput, { UITextInputProps } from 'Components/UIComponents/UITextInput';

import FieldInput from '../FieldInput';

export interface MaskedTextInputProps extends FieldRenderProps<string> {
  maskedInputProps: MaskedInputProps & Required<Pick<MaskedInputProps, 'mask'>>;
}

const MaskedTextInput = ({ ...fieldProps }: FieldRenderProps<string>) => {
  return (
    <FieldInput
      {...fieldProps}
      renderInput={(inputProps: UITextInputProps) => (
        <MaskedInput
          guide={false}
          {...(inputProps as any)}
          render={(ref, maskedProps) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { value, ...restInput } = inputProps;
            return <UITextInput {...restInput} {...(maskedProps as any)} ref={ref} />;
          }}
        />
      )}
    />
  );
};

export default MaskedTextInput;
